import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import { DefaultCopyBox } from '@lib/common';
import styled from '@xstyled/styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledInformation = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-weight: 600;\n  font-size: 16px;\n  margin-bottom: 6px;\n"])));
var QrBlock = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-top: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n"])));
var QrHint = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 13px;\n  color: #64748b;\n  text-align: center;\n"])));
var QrImage = styled.img(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 200px;\n  height: 200px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n"])));
export var ShareContent = function ShareContent(props) {
  var idNumber = props.idNumber,
      sharedLink = props.sharedLink,
      shareAssignmentTranslation = props.shareAssignmentTranslation,
      absoluteShareUrl = props.absoluteShareUrl,
      linkSectionLabel = props.linkSectionLabel,
      qrCodeHint = props.qrCodeHint;
  var copyBoxTranslation = {
    copy: shareAssignmentTranslation.copy,
    copied: shareAssignmentTranslation.copied
  };
  var urlToCopy = absoluteShareUrl !== null && absoluteShareUrl !== void 0 ? absoluteShareUrl : sharedLink;
  var linkLabel = linkSectionLabel !== null && linkSectionLabel !== void 0 ? linkSectionLabel : shareAssignmentTranslation.shareAssignmentNow;
  var qrSrc = absoluteShareUrl && "https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=".concat(encodeURIComponent(absoluteShareUrl));
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(StyledInformation, {
      children: linkLabel
    }), /*#__PURE__*/_jsx(DefaultCopyBox, {
      text: urlToCopy,
      copyBoxTranslation: copyBoxTranslation
    }), qrSrc && /*#__PURE__*/_jsxs(QrBlock, {
      children: [qrCodeHint ? /*#__PURE__*/_jsx(QrHint, {
        children: qrCodeHint
      }) : null, /*#__PURE__*/_jsx(QrImage, {
        src: qrSrc,
        alt: ""
      })]
    }), /*#__PURE__*/_jsx("br", {}), idNumber && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(StyledInformation, {
        children: shareAssignmentTranslation.shareByAssignmentId
      }), /*#__PURE__*/_jsx(DefaultCopyBox, {
        text: idNumber,
        copyBoxTranslation: copyBoxTranslation
      })]
    })]
  });
};